import { PercentPipe } from '@angular/common';
import { Component, computed, input } from '@angular/core';
import {
  MatProgressBarModule,
  ProgressBarMode,
} from '@angular/material/progress-bar';
import { AnalysisVersionStatus } from '@api-types/enums/analysis-version-status.enum';
import { TranslateModule } from '@ngx-translate/core';

type ProgressStatus =
  | AnalysisVersionStatus.CREATED
  | AnalysisVersionStatus.CALCULATING;

const PROGRESS_BAR_MODES: Record<ProgressStatus, ProgressBarMode> = {
  [AnalysisVersionStatus.CREATED]: 'indeterminate',
  [AnalysisVersionStatus.CALCULATING]: 'determinate',
};

@Component({
  selector: 'pm-analysis-progress',
  template: `
    <div class="flex flex-col gap-2">
      <div class="flex justify-between items-center text-sm text-gray-600">
        <span>{{ 'ANALYSIS.' + status() | translate }}...</span>
        @if (status() === AnalysisVersionStatus.CALCULATING) {
          <span>{{ progress() | percent: '1.0-0' }}</span>
        }
      </div>
      <mat-progress-bar [mode]="progressBarMode()" [value]="progress() * 100" />
    </div>
  `,
  imports: [MatProgressBarModule, TranslateModule, PercentPipe],
})
export class AnalysisProgressComponent {
  status = input.required<ProgressStatus>();
  progress = input<number>(0);

  protected readonly AnalysisVersionStatus = AnalysisVersionStatus;

  protected progressBarMode = computed(() => PROGRESS_BAR_MODES[this.status()]);
}
